import "bootstrap/js/dist/tab";
import Tooltip from "bootstrap/js/dist/tooltip";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import "@hotwired/turbo-rails";

/* global Turbo */
Turbo.session.drive = false;

library.add(faSearch, faCircleInfo);
dom.watch();

// see https://turbo.hotwired.dev/reference/events#frames for more info on the event lifecycle of turbo
document.addEventListener("turbo:load", () => {
  // ---------- START - utility ownership dropdown select
  let allCheck = document.getElementById("all_utils");
  let checkOptions = document.getElementsByClassName("owner-type");
  let form = document.forms.ufindersearch;
  let stateSelect = document.getElementById("state");
  let sort = document.getElementById("sort_by");
  let searchResults = document.getElementById("search-results");
  let zipButton = document.getElementById("zip_search");

  // Force browser history navigation to respect the url parameters
  updateRadioButtonsFromURL();

  // Show the right search option on load
  showSearchOption(
    document.querySelector(".search-type:checked")?.id
  );

  // return if form is not found
  // we don't want to execute the rest of the code if the form is not found
  if (!form) {
    return;
  }

  if (searchResults) {
    searchResults.classList.remove("loading");
  }
  if (sort) {
    sort.addEventListener("change", () => {
      form.requestSubmit();
    });
  }
  if (allCheck) {
    allCheck.addEventListener("change", () => {
      if (allCheck.checked) {
        for (var i = 0; i < checkOptions.length; i++) {
          checkOptions[i].checked = false;
        }
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      }
    });
  }

  // Listen for both change events (for tests, keyboard nav, programmatic changes)
  // and click events (for clicking the already-selected option)
  stateSelect.addEventListener("change", () => {
    document.getElementById("zip").value = "";
    document.getElementById("address").value = "";
    form.requestSubmit();
  });

  for (var i = 0; i < checkOptions.length; i++) {
    checkOptions[i].addEventListener("change", function () {
      if (Array.from(checkOptions).some((option) => option.checked)) {
        allCheck.checked = false;
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      } else {
        allCheck.checked = true;
        setSelectText(allCheck, checkOptions);
        form.requestSubmit();
      }
    });
  }


  function updateRadioButtonsFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const searchType = urlParams.get('search_type') || 'state'; // default to state

    // Update radio button to match URL
    const radioButton = document.querySelector(`input[name="search_type"][value="${searchType}"]`);
    if (radioButton) {
      radioButton.checked = true;
    }

    // Restore ONLY the form field value that matches the current search type
    const zipParam = urlParams.get('zip');
    const addressParam = urlParams.get('address');
    const stateParam = urlParams.get('state');

    const zipField = document.getElementById("zip");
    const addressField = document.getElementById("address");

    // Only restore the field for the active search type
    if (searchType === 'zip' && zipParam && zipField) {
      zipField.value = zipParam;
    } else if (searchType === 'address' && addressParam && addressField) {
      addressField.value = addressParam;
    } else if (searchType === 'state' && stateParam && stateSelect) {
      stateSelect.value = stateParam;
    }
  }

  function setSelectText(allCheck, checkOptions) {
    if (allCheck.checked) {
      document.getElementById("ownership-dropdown").textContent = "All";
      return;
    }

    let checked = Array.from(checkOptions)
      .filter((option) => option.checked)
      .map((option) => {
        let label = document.querySelector(`label[for="${option.id}"]`);
        return label ? label.textContent : "";
      });
    let selectText = checked.join(", ");
    if (checked.length > 2) {
      selectText = checked.length + " selected";
    }
    document.getElementById("ownership-dropdown").textContent = selectText;
  }

  function showSearchOption(selectedID) {
    if (!selectedID) {return;}

    const stateSearchEl = document.getElementById("state-search");
    const addressSearchEl = document.getElementById("address-search");
    const zipSearchEl = document.getElementById("zip-search");

    // Hide all search options first
    stateSearchEl.hidden = true;
    addressSearchEl.hidden = true;
    zipSearchEl.hidden = true;

    // Show only the selected search option
    if (selectedID == "search_type_state") {
      stateSearchEl.hidden = false;
      stateSearchEl.style.removeProperty('display');
    } else if (selectedID == "search_type_address") {
      addressSearchEl.hidden = false;
      addressSearchEl.style.removeProperty('display');
    } else {
      zipSearchEl.hidden = false;
      zipSearchEl.style.removeProperty('display');
    }
  }

  document.querySelectorAll(".allow-focus").forEach((element) => {
    element.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });
  // ---------- END - utility ownership dropdown select

  // Search type toggle
  document.querySelectorAll(".search-type").forEach((searchType) => {
    searchType.addEventListener("change", (event) => {
      var url = new URL(window.location.href);
      var currentSearchtype = url.searchParams.get("search_type");

      // Clear fields based on which search type we're switching FROM
      if (currentSearchtype == "state") {
        document.getElementById("zip").value = "";
        document.getElementById("address").value = "";
      } else if (currentSearchtype == "address") {
        document.getElementById("zip").value = "";
        stateSelect.value = "";
      } else {
        stateSelect.value = "";
        document.getElementById("address").value = "";
      }

      showSearchOption(event.target.id);
    });
  });

  zipButton.addEventListener("click", () => {
    stateSelect.selectedIndex = 0;
  });

  // Show toggle loading for any page changes
  document.querySelectorAll(".page-link").forEach((pageLink) => {
    pageLink.addEventListener("click", () => {
      searchResults.classList.add("loading");
    });
  });

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });
});

document.addEventListener("turbo:submit-start", () => {
  document.getElementById("search-results")?.classList.add("loading");
});
